import { Button } from "antd";
import { useHistory } from "react-router-dom";

import Card from "./../components/ui/card";
import Content from "../components/ui/content";
import Header from "../components/ui/header";

import icon from "./../assets/images/file.svg";

const NotFoundPage = () => {
  const history = useHistory();

  const onBack = () => {
    history.push("/acta");
  };

  return (
    <Card>
      <Header />
      <Content>
        <div className="status">
          <img src={icon} alt="Not Found" />
          <h1>¡Hola! Su acta se esta procesando.</h1>
          <p>
            Por favor reintente adjuntar la documentación en las próximas 24hs
            hábiles
          </p>
          <p>¡Muchas Gracias!</p>
          <Button type="secondary" onClick={onBack}>
            Volver
          </Button>
        </div>
      </Content>
    </Card>
  );
};

export default NotFoundPage;
